import { isValuePresent } from 'helpers/utils';
import { forwardRef } from 'react';
import {
  type InputAttributes,
  type NumberFormatValues,
  NumericFormat,
  type NumericFormatProps,
  type SourceInfo,
} from 'react-number-format';
import type { NumberFormatProps } from './NumberFormat.types';

const NumberFormat = forwardRef<NumericFormatProps<InputAttributes>, NumberFormatProps>(
  ({ displayType = 'input', onChange, value, allowDecimal = true, ...props }, ref) => {
    const fieldValue =
      !allowDecimal && isValuePresent(value, ['-']) ? Math.trunc(Number(value)) : value;

    const handleValueChange = (values: NumberFormatValues, sourceInfo: SourceInfo) => {
      if (sourceInfo.source !== 'prop' && displayType === 'input') {
        // Using values.floatValue ensures the stored value matches what's displayed

        onChange?.({
          target: {
            name: props.name,
            // `??` only guards null/undefined; the library's blur path can emit
            // floatValue: NaN (parseFloat('')), which would stringify to "NaN".
            value: Number.isFinite(values.floatValue) ? String(values.floatValue) : '',
          },
        });
      }
    };

    return (
      <NumericFormat
        {...props}
        value={fieldValue}
        allowNegative={false}
        allowLeadingZeros={false}
        decimalScale={allowDecimal ? 2 : 0}
        getInputRef={displayType === 'input' ? ref : null}
        onValueChange={handleValueChange}
        thousandSeparator
        valueIsNumericString
        autoComplete="off"
        inputMode={allowDecimal ? 'decimal' : 'numeric'}
      />
    );
  },
);

export default NumberFormat;
